import React from "react";

const Info = () => {
  return (
    <div className="has-text-centered " id="hakkimda">
      <h1 className="is-size-4 ">Diş Hekimi Batuhan Hıdıroğlu</h1>
      <br />
      <p className="is-size-5 ">
        2015 yılında Yeditepe Diş Hekimliği Fakültesi’nden mezun olan Batuhan
        Hıdıroğlu, aynı yıl İstanbul Üniversitesi Diş Hekimliği Üniversitesi
        Ağız Diş ve Çene Cerrahisi Anabilim Dalı’nda doktora eğitimine
        başlamıştır. 2018 yılından itibaren memleketi olan İzmir’e yerleşip,
        kendi özel muayenehanesinde hizmet vermektedir.
      </p>
      <br />
      <div className="container" id="iletisim">
        <h2 className="is-size-5">Telefon</h2>
        <h3 className="is-size-5">
          <a href="tel:02322161312">(0232) 216 13 12</a>
        </h3>
        <h3 className="is-size-5">
          <a href="tel:05321767482">(0532) 176 74 82</a>
        </h3>
        <br />
        <div className="adress has-text-centered is-size-5">
          <h2 className="is-size-4">Adres</h2>
          <p>Mithatpaşa Caddesi</p>
          <p>No:301 Daire 4</p>
          <p>Narlıdere - İzmir</p>
        </div>
      </div>
    </div>
  );
};

export default Info;



// WEBPACK FOOTER //
// ./src/components/main/Info.js